import { Injector } from '@angular/core';
import { HYPOTHETICALS_APP_STATE_SLICE_KEY, HYPOTHETICALS_STATE_KEYS } from '../constants';
import { AppStateService } from 'NewAngular/services/app-state.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import * as i0 from "@angular/core";
export class HypotheticalsAppStateManager extends AppStateManager {
    // AppStateService is lazily resolved to avoid a circular dependency: this service is
    // providedIn: 'root' and AppStateService depends on ActivatedRoute, which isn't available
    // on pages without a Router (e.g. quote pages that import HypotheticalsSharedModule).
    constructor(injector) {
        super(null);
        this.injector = injector;
    }
    resolveAppStateService() {
        if (this.appStateService === null) {
            this.appStateService = this.injector.get(AppStateService, null);
        }
    }
    initAppState() {
        this.resolveAppStateService();
        if (!this.appStateService)
            return;
        this.appStateService.setStateSlice(HYPOTHETICALS_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(HYPOTHETICALS_STATE_KEYS);
        this.appStateService.start();
    }
}
HypotheticalsAppStateManager.ɵfac = function HypotheticalsAppStateManager_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HypotheticalsAppStateManager)(i0.ɵɵinject(i0.Injector)); };
HypotheticalsAppStateManager.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HypotheticalsAppStateManager, factory: HypotheticalsAppStateManager.ɵfac, providedIn: 'root' });
